export const url = {
  apiUrl: process.env.REACT_APP_API_URL,
};
